import { Injectable, inject } from '@angular/core';
import { tap } from 'rxjs';
import { JwTokenModel } from '../core/api/models';
import { AccountApiService } from '../core/api/services';

@Injectable({
  providedIn: 'root',
})
export class ParentAuthService {

  private accountApiService = inject(AccountApiService);

  public tokenInfo: JwTokenModel | null = JSON.parse(localStorage.getItem('parentTokenInfo') || 'null');

  get identity(): { name?: string; sid?: string; groupsid?: string } {
    try {
      const encoded = this.tokenInfo?.access_token?.split('.')[1];
      if (!encoded) return {};
      const decoded = atob(encoded.replace(/-/g, '+').replace(/_/g, '/'));
      return JSON.parse(new TextDecoder().decode(Uint8Array.from(decoded, c => c.charCodeAt(0))));
    } catch { return {}; }
  }

  get storageScope(): string { return encodeURIComponent(this.identity.groupsid ?? '') + ':' + encodeURIComponent(this.identity.sid ?? ''); }

  signOut(): void {
    this.tokenInfo = null;
    localStorage.removeItem('parentTokenInfo');
  }

  public signIn(code: string) {
    return this.accountApiService.AuthenticateParent({ body: { code: code } })
      .pipe(tap(token => {
        this.tokenInfo = token;
        localStorage.setItem('parentTokenInfo', JSON.stringify(token));
      }));
  }

  public isSignedIn(): boolean {
    return this.tokenInfo?.expires_at != null
      && new Date(this.tokenInfo.expires_at) > new Date();
  }
}
